export const fetchToken = async (token) => {
    let userState;
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}backend/auth/token_client`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ` + token
        }
    });
    response.ok ? userState = await response.json() : userState = null;
    return userState;
}

export const fetchUser = async (accessToken) => {
    let userData;
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}backend/auth/users/me`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ` + accessToken
        }
    });
    response.ok ? userData = await response.json() : userData = null;
    return userData;
}
